import { loadProvider } from "@smart/bridge-providers-dom";
import { Button, StatusOverlay } from "@smart/itops-sb-design-system-dom";

import { Instructions } from "./instructions";

export type ExistingProps = {
  email?: string;
  provider?: string;
  errorCode?: string;
};

export const Existing = ({ email, provider, errorCode }: ExistingProps) => {
  const loaded = loadProvider(provider);

  return (
    <form className="relative my-[1rem] max-w-[80rem] w-[98%] flex flex-col gap-small">
      {errorCode && <StatusOverlay status="error" errorCode={errorCode} />}
      <Instructions image={loaded?.icon} alt={loaded?.label}>
        You&apos;re currently signed in{email ? ` as ${email}.` : "."}
      </Instructions>
      <div className="flex justify-start gap-small">
        <Button
          text="Continue"
          variant="primarySubtle"
          onClick={() => {
            window.location.href = "/api/recall";
          }}
        />
        <Button
          text="Sign Out"
          variant="destructiveSubtle"
          onClick={() => {
            window.location.href = "/api/clear";
          }}
        />
      </div>
    </form>
  );
};
